<template>
  <v-container grid-list-md>
    <v-layout
      row
      wrap
    >
      <v-flex xs12>
        <h2>{{ heading }}</h2>
        <span class="subheading">
          {{ subheading }}
        </span>
        <v-divider class="my-3" />
      </v-flex>
      <v-flex xs6>
        <agent-card :agent="userInfo">
          <template v-slot:action>
            <v-btn @click="infoEditDialog = true">
              Edit
            </v-btn>
          </template>
        </agent-card>
      </v-flex>
      <v-dialog 
        v-model="infoEditDialog" 
        max-width="850px"
        min-height="400px"
      >
        <agent-form :agent="userInfo">
          <template v-slot:action="{ agent, validate }">
            <v-btn 
              color="default" 
              @click="infoEditDialog = false"
            >
              Close
            </v-btn>
            <v-btn 
              color="primary" 
              @click="save(agent, validate)"
            >
              Save
            </v-btn>
          </template>
        </agent-form>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import AgentCard from '@/components/agent/AgentCard.vue'
import AgentForm from '@/components/agent/AgentForm.vue'

export default {
  name: 'Profile',
  components: {
    'agent-card': AgentCard,
    'agent-form': AgentForm
  },
  data() {
    return {
      userInfo: {},
      infoEditDialog: false,
    }
  },
  computed: {
    heading() {
      return 'Company Profile'
    },
    subheading() {
      return ''
    },
    ...mapState([
      'user',
    ])
  },
  created() {
    this.$store.dispatch('agents/one', this.user.userId)
      .then(data => {
        this.userInfo = data
      })
  },
  methods: {
    save(agent, validate) {
      if(!validate()) { return }
      this.$store.dispatch('agents/update', agent)
        .then(() => {
          this.$store.dispatch('showMessage', { state: 'success', message: 'Company info have been updated' })
          this.userInfo = agent
          this.infoEditDialog = false
        })
        .catch(() => this.$store.dispatch('showMessage', { state: 'error', message: 'Something went wrong, we were unable to update your info' }))
    }
  }
}
</script>

<style>

</style>